// Sort rank for a GICS tier, broadest (Sector) to most specific (Sub-Industry).
// Used to order GICS results from the widest classification down to the finest.

export const gicsTierRank = (tier: string | undefined): number => {
  switch (tier) {
    case 'Sector':
      return 1;
    case 'Industry Group':
      return 2;
    case 'Industry':
      return 3;
    case 'Sub-Industry':
      return 4;
    default:
      return 5;
  }
};
